import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import { HttpUtilService } from './http-util-service';
import { User } from '../models/users';
import { Observable } from 'rxjs';

import * as firebase from 'firebase';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AngularFireDatabase } from 'angularfire2/database';


@Injectable()
export class LoginService {
  user: Observable<firebase.User>;

  constructor(public afAuth: AngularFireAuth, public router: Router, private toastr: ToastrService,
    private db: AngularFireDatabase) {
    this.user = afAuth.authState;
  }

  public login(mail:  string, password: string) {
    return new Promise((resolve, reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(mail, password).then((user) => {
        localStorage['token'] = user.uid;
          this.toastr.success('Seja bem vindo');
        this.router.navigate(['/controle-seap']);
      }).catch((error) => {
        console.log(error);
        this.toastr.error('Dados inválidos!');
        this.router.navigate(['/login']);
      });
    }).catch((error) => {
      this.toastr.error('Dados inválidos!');
      this.router.navigate(['/login']);
    });

  }

  public logout() {
    localStorage['token'] = null;
    return this.afAuth.auth.signOut();
  }

  public createAccount(mail, password) {
    return this.afAuth.auth.createUserWithEmailAndPassword(mail, password);
  }
}
